import React from 'react';

import { Button } from '@mui/material';

import { formKeys } from '../../../../helpers/Constants';
import strings from '../../../../localization';

import styles from './styles';

export const crumbs = (goBack:()=>void) =>
  [
    <Button
      variant="text"
      key="campaigns"
      onClick={goBack}
      sx={[styles.noUnderline, styles.prevLink]}
    >
      {strings.campaigns}
    </Button>,
    <Button
      key="configure-email"
      variant="text"
      sx={styles.noUnderline}
    >
      {strings.createEmailTemplate}
    </Button>,
  ];

export const emailTemplateItems = () =>
  [
    {
      key: formKeys.registrationEmail,
      label: strings.leadInviteEmail,
    },
    {
      key: formKeys.existingUserEmail,
      label: strings.inviteExistingUser,
    },
    {
      key: formKeys.activationEmail,
      label: strings.accountActivatedEmailImage,
    },
    {
      key: formKeys.bookingEmail,
      label: strings.formatString(
        strings.bookingEmailFormat,
        strings.singleDay,
      ) as string,
    },
    {
      key: formKeys.multiBookingEmail,
      label: strings.formatString(
        strings.bookingEmailFormat,
        strings.mds,
      ) as string,
    },
  ];
